import getVideoId from 'get-video-id'
import { get } from '@rails/request.js'
import Trix from 'trix'

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['editor', 'dialog', 'input']

  async insert() {
    this.inputTarget.setCustomValidity('')

    if (this.inputTarget.willValidate && !this.inputTarget.checkValidity()) {
      this.focusInvalidInput()
    } else {
      const { id, service } = getVideoId(this.inputTarget.value)

      if (service === 'youtube') {
        const response = await get(`/action_text/youtube_attachments/${id}`)

        if (response.ok) {
          const { content, sgid } = await response.json
          const attachment = new Trix.Attachment({ content, sgid })

          this.editorTarget.editor.insertAttachment(attachment)
          this.hideDialog()
        } else {
          this.inputTarget.setCustomValidity('Failed to attach the YouTube video.')
          this.focusInvalidInput()
        }
      } else {
        this.inputTarget.setCustomValidity('Not a valid YouTube URL.')
        this.focusInvalidInput()
      }
    }
  }

  focusInvalidInput() {
    this.inputTarget.setAttribute("data-trix-validate", "")
    this.inputTarget.classList.add("trix-validate")
    this.inputTarget.focus()
    this.inputTarget.reportValidity()
  }

  hideDialog() {
    this.dialogTarget.removeAttribute("data-trix-active")
    this.dialogTarget.classList.remove("trix-active")

    this.inputTarget.setAttribute("disabled", "disabled")
    this.inputTarget.removeAttribute("data-trix-validate")
    this.inputTarget.classList.remove("trix-validate")
  }
}
